/**
 * @generated SignedSource<<497d3c4cead9bbbb40e0821934e5247f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ManageSignatureCertificateModal_sessionInfo_Query$variables = {};
export type ManageSignatureCertificateModal_sessionInfo_Query$data = {
  readonly sessionInfo: {
    readonly digitalSigningCertificates: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly email: string;
          readonly id: string;
          readonly name: string;
          readonly pfx: string;
          readonly validFrom: {
            readonly utcDatetime: ISO8601DateTimeString;
          };
          readonly validUntil: {
            readonly utcDatetime: ISO8601DateTimeString;
          };
        } | null;
      }>;
    } | null;
    readonly member: {
      readonly email: string;
      readonly id: string;
      readonly name: string;
    } | null;
  };
};
export type ManageSignatureCertificateModal_sessionInfo_Query = {
  response: ManageSignatureCertificateModal_sessionInfo_Query$data;
  variables: ManageSignatureCertificateModal_sessionInfo_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Member",
  "kind": "LinkedField",
  "name": "member",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "utcDatetime",
    "storageKey": null
  }
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberDigitalSigningCertificateConnection",
  "kind": "LinkedField",
  "name": "digitalSigningCertificates",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MemberDigitalSigningCertificateEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MemberDigitalSigningCertificate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pfx",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "DateTime",
              "kind": "LinkedField",
              "name": "validFrom",
              "plural": false,
              "selections": (v4/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "DateTime",
              "kind": "LinkedField",
              "name": "validUntil",
              "plural": false,
              "selections": (v4/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ManageSignatureCertificateModal_sessionInfo_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SessionInfo",
        "kind": "LinkedField",
        "name": "sessionInfo",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ManageSignatureCertificateModal_sessionInfo_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SessionInfo",
        "kind": "LinkedField",
        "name": "sessionInfo",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v5/*: any*/),
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "374df97f3b40898804fb8888f4ad2b8d",
    "id": null,
    "metadata": {},
    "name": "ManageSignatureCertificateModal_sessionInfo_Query",
    "operationKind": "query",
    "text": "query ManageSignatureCertificateModal_sessionInfo_Query {\n  sessionInfo {\n    member {\n      id\n      name\n      email\n    }\n    digitalSigningCertificates {\n      edges {\n        node {\n          id\n          name\n          email\n          pfx\n          validFrom {\n            utcDatetime\n          }\n          validUntil {\n            utcDatetime\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ccce4bcc12ce8c15a5ec83b2513d6188";

export default node;
